document.addEventListener('DOMContentLoaded', () => {
    const resultsContainer = document.querySelector('[data-search-container]');
    const searchButton = document.querySelector('[data-search-button]');
    const keywordField = document.querySelector('[data-keyword-search]');
    const articleCategory = document.querySelector('[data-article-category]');
    const currentPage = document.querySelector('[data-currentPage]');
    const queryUrl = '/umbraco/surface/BlogSearchSurface/BlogArticleSearch';
    const loadingContainer = document.querySelector('[data-loading]');

    if (!resultsContainer) return;

    const baseUrl = (resultsContainer.dataset.baseUrl || '').replace(/\/+$/, '');

    const toSlug = (value) => {
        if (!value) return '';
        return value
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/[\s-]+/g, '-')
            .replace(/^-+|-+$/g, '');
    };

    const getCategoryOptions = () => articleCategory ? Array.from(articleCategory.options) : [];

    const getCategoryNameFromSlug = (slug) => {
        if (!slug) return '';
        const match = getCategoryOptions().find(option => option.value && toSlug(option.value) === slug);
        return match ? match.value : '';
    };

    const getCategoryFromPath = (pathname) => {
        if (!baseUrl) return '';
        const trimmedPath = pathname.replace(/\/+$/, '');
        if (trimmedPath === baseUrl) return '';
        if (!trimmedPath.startsWith(`${baseUrl}/`)) return '';
        const slug = trimmedPath.slice(baseUrl.length + 1).split('/')[0];
        return getCategoryNameFromSlug(slug);
    };

    async function updateSearch(queryString, pushToHistory = true) {
        loadingContainer.style.display = 'block';
        if(resultsContainer.querySelector('[data-blog-list]')) {
            resultsContainer.querySelector('[data-blog-list]').style.display = 'none';
        }
        const cleanQuery = queryString.startsWith('?') ? queryString : `?${queryString}`;
        const fetchUrl = `${queryUrl}${cleanQuery}`;

        try {
            const response = await fetch(fetchUrl, {
                headers: {'X-Requested-With': 'XMLHttpRequest'}
            });

            if (!response.ok) return;

            const html = await response.text();

            resultsContainer.innerHTML = html;

            if (pushToHistory) {
                const searchParams = new URLSearchParams(cleanQuery);
                const category = searchParams.get('category');
                const search = searchParams.get('search');
                const pageNumber = searchParams.get('pageNumber');

                const categorySlug = toSlug(category);
                let pushStateUrl = categorySlug && baseUrl ? `${baseUrl}/${categorySlug}` : (baseUrl || window.location.pathname);

                const trailingParams = new URLSearchParams();
                if (search) trailingParams.append('search', search);
                if (pageNumber && parseInt(pageNumber, 10) > 1) trailingParams.append('pageNumber', pageNumber);

                const trailingQuery = trailingParams.toString();
                if (trailingQuery) pushStateUrl += `?${trailingQuery}`;

                window.history.pushState({queryString}, '', pushStateUrl);
            }

            resultsContainer.scrollIntoView({behavior: 'smooth', block: 'start'});

        } catch (err) {
            console.error("Search Error:", err);
        } finally {
            loadingContainer.style.display = 'none';
            if(resultsContainer.querySelector('[data-blog-list]')) {
                resultsContainer.querySelector('[data-blog-list]').style.display = 'block';
            }
        }
    }

    document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-pagingbutton]');
        const pagingBack = event.target.closest('[data-paging-back]');
        const pagingNext = event.target.closest('[data-paging-next]')
        if (button) {
            const pageNumber = button.getAttribute('data-pagenumber');
            performSearch(pageNumber);
        }
        if(pagingBack)
        {
           const pageNumber = pagingBack.getAttribute('data-pagenumber');
            performSearch(pageNumber);
        }
        if(pagingNext)
        {
            const pageNumber = pagingNext.getAttribute('data-pagenumber');
            performSearch(pageNumber);
        }
    });

    function performSearch(pageNumber = 1) {
        const params = new URLSearchParams();

        if (keywordField?.value) params.append('search', keywordField.value);
        if (articleCategory?.value) params.append('category', articleCategory.value);
        if(pageNumber)
        {
            params.append('pageNumber', pageNumber);
        } else {
            if (currentPage?.Value) params.append('pageNumber', currentPage.Value)
        }
        updateSearch(`?${params}`);
    }


    searchButton?.addEventListener('click', (e) => {
        e.preventDefault();
        performSearch();
    });

    keywordField?.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            performSearch();
        }
    });


    resultsContainer.addEventListener('click', (e) => {
        const link = e.target.closest('[data-search-link]');
        if (link) {
            e.preventDefault();
            const href = link.getAttribute('href');
            updateSearch(href);
        }
    });

    articleCategory?.addEventListener('change', (e) => {
        performSearch();
    })

    window.addEventListener('popstate', () => {
        const currentParams = new URLSearchParams(window.location.search);
        const category = getCategoryFromPath(window.location.pathname);

        if (keywordField) keywordField.value = currentParams.get('search') || '';
        if (articleCategory) articleCategory.value = category;

        const params = new URLSearchParams();
        if (currentParams.get('search')) params.append('search', currentParams.get('search'));
        if (category) params.append('category', category);
        if (currentParams.get('pageNumber')) params.append('pageNumber', currentParams.get('pageNumber'));

        updateSearch(`?${params}`, false);
    });
});
